<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
};
</script>

<style lang="scss">
// CoreUI Icons Set
@import "~@coreui/icons/css/coreui-icons.min.css";
/* Import Font Awesome Icons Set */
$fa-font-path: "~@fortawesome/fontawesome-free/webfonts";
@import "~@fortawesome/fontawesome-free/scss/fontawesome";
@import "~@fortawesome/fontawesome-free/scss/solid";
@import "~@fortawesome/fontawesome-free/scss/regular";
/* Import Simple Line Icons Set */
//$simple-line-font-path: '~simple-line-icons/fonts/';
//@import '~simple-line-icons/scss/simple-line-icons.scss';
/* Import Bootstrap Vue Styles */
@import "~bootstrap-vue/dist/bootstrap-vue.css";
/* Import Flag Icons */
@import "~flag-icon-css/css/flag-icons.min.css";
// Import Main styles for this application
@import "assets/scss/style";
//@import "assets/scss/themes/fbf";
</style>
